import React, { useEffect, useRef, useState } from 'react';
import styles from './Loader.module.css';

interface LoaderProps {
	visible: boolean;
}

const Loader: React.FC<LoaderProps> = ({ visible }) => {
	const [showSpinner, setShowSpinner] = useState(false);
	const timerRef = useRef<number | null>(null);

	// Blocca lo scroll quando visibile
	useEffect(() => {
		document.body.style.overflow = visible ? 'hidden' : '';
		return () => {
			document.body.style.overflow = '';
		};
	}, [visible]);

	// Delay di 2s prima di mostrare lo spinner
	useEffect(() => {
		if (visible) {
			timerRef.current = window.setTimeout(() => setShowSpinner(true), 1000);
		} else {
			if (timerRef.current) clearTimeout(timerRef.current);
			setShowSpinner(false);
		}

		return () => {
			if (timerRef.current) clearTimeout(timerRef.current);
		};
	}, [visible]);

	if (!visible || !showSpinner) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.loader}></div>
		</div>
	);
};

export default Loader;
